import {SizeTokenValue} from 'common';
import {DownloadIcon} from 'icons';
import {Loader} from 'Loader';

import {Chip} from 'Chip';

import {useUploadedFile} from './hook';

import type {ChipProps} from 'Chip';

import type {FileItem, UploadedFilesProps} from 'FileUploader/types';

import type {UploadedFileProps} from './hook';

import type {ReactNode} from 'react';

function UploadedFile<T>(props: UploadedFileProps<T>) {
  const {item} = props;

  const {isHidden, isError, isLoading, onClick, onDelete} = useUploadedFile(props);

  if (isHidden) {
    return null;
  }

  let startAdornment: ReactNode;

  if (isLoading) {
    startAdornment = <Loader size={SizeTokenValue.Small} />;
  } else if (item.url) {
    startAdornment = <DownloadIcon size={SizeTokenValue.Small} />;
  }

  const chipProps: ChipProps = {
    onClick,
    startAdornment,
    onDelete,

    label: item.name,
    tooltip: item.tooltip,
    href: item.url,
    error: isError,

    maxLength: props.maxLabelLength,
    maxLengthFunc: props.maxLabelLengthFunc,

    target: '_blank',
  };

  return <Chip {...chipProps} />;
}

export function getUploadedFile<T>(item: FileItem<T>, props: UploadedFilesProps<T>) {
  return <UploadedFile key={item.id} item={item} {...props} />;
}
